<section id="/guide/policy">

  <h3 class="guide__heading heading heading_level_3">개인정보처리방침</h3>

  <h4 class="guide__heading heading heading_level_4">제1장 총칙</h4>

  <p class="text">
    <br />
    “커피멘토”를 운영하는 주식회사 공간몬스터(이하 “회사”라고 합니다)에서 운영하는 홈페이지 (https://www.coffeementor.co.kr, 이하 “홈페이지”라고 합니다)는 「개인정보보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.<br/>
    <br />
    - 이 개인정보처리방침은 2022년 5월 6부터 적용됩니다.
    <br />
    <br />
  </p>

  <h5 class="guide__heading heading heading_level_5">제1조(개인정보의 처리 목적)</h5>
  <ol class="guide__text text">
    <li>“회사” 는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. 가맹문의, 서비스 부정이용 방지 등을 목적으로 개인정보를 처리합니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제2조(개인정보의 처리 및 보유 기간)</h5>
  <ol class="guide__text text">
    <li>“회사” 는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</li>
    <li>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제3조(개인정보의 제3자 제공에 관한 사항)</h5>

  <ol class="guide__text text">
    <li>“회사” 는 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</li>
    <li>
      “회사” 는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.<br/>
      <ul class="guide__list text">
        <li>개인정보를 제공받는 자: (주) 공간몬스터</li>
        <li>제공받는 자의 개인정보 이용목적: 이름, 휴대전화번호, 이메일</li>
        <li>제공받는 자의 보유.이용기간: 김지수(3년)</li>
      </ul>
    </li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제4조(개인정보처리의 위탁에 관한 사항)</h5>
  <ol class="guide__text text">
    <li>
      “회사” 는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.<br/>
      <ul class="guide__list text">
        <li>위탁받는 자 (수탁자): (주) 공간몬스터</li>
        <li>위탁하는 업무의 내용: 이름, 휴대전화번호, 이메일</li>
        <li>위탁기간: 3년</li>
      </ul>
    </li>
    <li>“회사” 는 위탁계약 체결시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</li>
    <li>위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제5조(정보주체와 법정대리인의 권리·의무 및 그 행사방법에 관한 사항)</h5>
  <ol class="guide__text text">
    <li>정보주체는 “회사” 에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.</li>
    <li>제1항에 따른 권리 행사는“회사” 에 대해 「개인정보 보호법」 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 “회사” 는 이에 대해 지체 없이 조치하겠습니다.</li>
    <li>제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다.이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</li>
    <li>개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.</li>
    <li>개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</li>
    <li>“회사” 는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</li>
  </ol>


  <h5 class="guide__heading heading heading_level_5">제6조(개인정보의 안전성 확보조치에 관한 사항)</h5>
  <p class="text">“회사” 는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>

  <ol class="guide__text text">
    <li>
      정기적인 자체 감사 실시<br/>
      개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.
    </li>
    <li>
      해킹 등에 대비한 기술적 대책<br/>
      “회사” 는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
    </li>
  </ol>


  <h5 class="guide__heading heading heading_level_5">제7조(개인정보를 자동으로 수집하는 장치의 설치·운영 및 그 거부에 관한 사항)</h5>
  <ol class="guide__text text">
    <li>“회사” 는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.</li>
    <li>
      쿠키는 “홈페이지” 를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.

      <ul class="guide__list guide__list_style_hangul text ">
        <li>쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</li>
        <li>쿠키의 설치•운영 및 거부 : 웹브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.</li>
        <li>쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</li>
      </ul>
    </li>
  </ol>


  <h5 class="guide__heading heading heading_level_5">제8조(추가적인 이용·제공 판단기준)</h5>
  <ol class="guide__text text">
    <li>
      “회사” 는 ｢개인정보 보호법｣ 제15조제3항 및 제17조제4항에 따라 ｢개인정보 보호법 시행령｣ 제14조의2에 따른 사항을 고려하여 정보주체의 동의 없이 개인정보를 추가적으로 이용·제공할 수 있습니다.<br/>
      이에 따라 “회사” 가 정보주체의 동의 없이 추가적인 이용·제공을 하기 위해서 다음과 같은 사항을 고려하였습니다.
    </li>
    <li>개인정보를 추가적으로 이용·제공하려는 목적이 당초 수집 목적과 관련성이 있는지 여부</li>
    <li>개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 추가적인 이용·제공에 대한 예측 가능성이 있는지 여부</li>
    <li>개인정보의 추가적인 이용·제공이 정보주체의 이익을 부당하게 침해하는지 여부</li>
    <li>가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부</li>
    <li>추가적인 이용·제공 시 고려사항에 대한 판단기준은 사업자/단체 스스로 자율적으로 판단하여 작성·공개함</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제9조(가명정보를 처리하는 경우 가명정보 처리에 관한 사항)</h5>
  <p class="text">“회사” 는 다음과 같은 목적으로 가명정보를 처리하고 있습니다.</p>
  <ol class="guide__text text">
    <li>
      가명정보의 처리 목적<br/>
      - 직접작성 가능합니다.
    </li>
    <li>
      가명정보의 처리 및 보유기간<br/>
      - 직접작성 가능합니다.
    </li>
    <li>
      가명정보의 제3자 제공에 관한 사항(해당되는 경우에만 작성)<br/>
      - 직접작성 가능합니다.
    </li>
    <li>
      가명정보 처리의 위탁에 관한 사항(해당되는 경우에만 작성)<br/>
      - 직접작성 가능합니다.
    </li>
    <li>
      가명처리하는 개인정보의 항목<br/>
      - 직접작성 가능합니다.
    </li>
    <li>
      법 제28조의4(가명정보에 대한 안전조치 의무 등)에 따른 가명정보의 안전성 확보조치에 관한 사항<br/>
      - 직접작성 가능합니다.
    </li>
  </ol>


  <h5 class="guide__heading heading heading_level_5">제10조 (개인정보 보호책임자에 관한 사항)</h5>
  <ol class="guide__text text">
    <li>
      “회사” 는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.<br/>
      <ul class="guide__list text">
        <li>개인정보 보호책임자</li>
        <li>성명: 김지수</li>
        <li>직책: 대표</li>
        <li>직급: 대표</li>
        <li>연락처: 070-4261-3908, spacemonster7@naver.com</li>
      </ul>
    </li>
    <li>
      개인정보 보호 담당부서로 연결됩니다.
      <ul class="guide__list text">
        <li>개인정보 보호 담당부서</li>
        <li>부서명: 마케팅커뮤니케이션</li>
        <li>담당자: 손중혁</li>
        <li>연락처: 070-4261-3908, spacemonster7@naver.com</li>
      </ul>
    <li>정보주체께서는 “회사” 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. “회사” 는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제11조(개인정보의 열람청구를 접수·처리하는 부서)</h5>
  <p class="text">정보주체는 ｢개인정보 보호법｣ 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다.</p>
  <p class="text">“회사” 는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.</p>
  <ul class="guide__list text">
    <li>개인정보 열람청구 접수·처리 부서</li>
    <li>부서명 : 마케팅커뮤니케이션</li>
    <li>담당자 : 손중혁</li>
    <li>연락처 : 070-4261-3908, spacemonster7@naver.com</li>
  </ul>


  <h5 class="guide__heading heading heading_level_5">제12조(정보주체의 권익침해에 대한 구제방법)</h5>
  <p class="text">정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.</p>
  <ol class="guide__text text">
    <li>개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)</li>
    <li>개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)</li>
    <li>대검찰청 : (국번없이) 1301 (www.spo.go.kr)</li>
    <li>경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)</li>
  </ol>

  <p class="text">「개인정보보호법」제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.</p>

  <p class="text">- 행정심판에 대해 자세한 사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를 참고하시기 바랍니다.</p>

  <h5 class="guide__heading heading heading_level_5">제13조(개인정보 처리방침 변경)</h5>
  <ol class="guide__text text">
    <li>이 개인정보처리방침은 2022년 5월 6부터 적용됩니다.</li>
    <li>이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</li>
  </ol>
</section>
